import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface DetailAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.rfqs.inviteSuppliers
function* inviteSuppliersSaga({ payload }) {
    try {
        const response = yield axios.get(`/companies/rfqs/suggested-companies/${payload.id}`)
        if (response.success) {
            yield put(onSuccess({ data: response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* inviteSuppliers(): any {
    yield takeLatest<DetailAction>(onRequest, inviteSuppliersSaga)
}

export default inviteSuppliers
